import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';
import type { GeneralLayout } from '@eliadmin/core/src/api/general/types/general-layout-types';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import Image from '@eliadmin/core/src/components/image/image-wrapped';
import Link from '@eliadmin/core/src/components/link';

export type HeaderLogoProps = {
  generalLayout: GeneralLayout['data'];
};

export function HeaderLogo({ generalLayout }: HeaderLogoProps) {
  return (
    <Link
      href={ROUTES.HOME() ?? '#'}
      className={cn('flex items-center justify-center', 'ea-header-logo')}
      prefetch={false}
    >
      {generalLayout.header.logo ? (
        <Image
          src={generalLayout.header.logo.url}
          alt={resolveImageAlt(generalLayout?.header?.logo, undefined)}
          width="0"
          height="0"
          sizes="100vw"
          className={cn('h-[26px] w-auto md:h-[34px] lg:h-12', 'ea-header-logo__image')}
        />
      ) : (
        <div data-ea-visual-tag="h1" className={cn('text-2xl font-bold', 'ea-header-logo__text')}>
          {(generalLayout.site_name?.trim() || '')}
        </div>
      )}
    </Link>
  );
}
